/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: supervision-webapp-contrib
 * Version: 7.1.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/*
 * kProcessBuilder jQuery plugin
 *
 * version 0.0.1
 *
 * Kosmos
 *
 * Files below need to be referenced in the calling page for the component to run correctly :
 *
 * 	JS :
 * 	- jQuery ( jquery-XX.XX.XX.js )
 *  - jQuery UI ( jquery-ui-XX.XX.XX.custom.js )
 *  - jQuery Sort Functions ( jquery.ksort-functions-XX.XX.XX.js )
 *
 *  CSS :
 *  - a jQuery UI theme ( jquery-ui-XX.XX.XX.css )
 *  - component style ( kProcessBuilder-XX.XX.XX.css )
 *
 * Versions :
 *
 * 0.0.1 :
 *  - Initialization
 *
 */

(function($) {

$.kProcessBuilder = function (root, options) {
    var $kProcessBuilder = $(root),

    settings,

    $parent,
	$parentList,
	$composition,
	$compositionList,

	$source,

	$toolbox,
	toolbox = {
		$addButton : null,
		$editButton : null,
		$removeButton : null
	},

	$oldEditToolbox,
	$oldSortToolbox,

	ua = navigator.userAgent;

    // Initialize the component
    function init(){

    	// Default settings
    	var defaults = {

    		// Should the constructor return an instance of the created object
			instance : false,

			// Labels
			parentLabel: LOCALE_BO.kprocessbuilder.traitements_disponibles,
			compositionLabel: LOCALE_BO.kprocessbuilder.ordonnancement,

			// Ignore interactions on items carrying this class
			ignore: '.ignore',

			// Retro actions support
			oldMode: false,

			// Add functionnalities
			addAction: function(){},
			onBeforeItemAdd: function(){},
			onAfterItemAdd: function(){},

			// Edit functionnalities
			editable: false,
			editAction: function(){},
			onBeforeItemEdit: function(){},
			onAfterItemEdit: function(){},

			// Remove functionnalities
			removable: true,
			onBeforeItemRemove: function(){},
			onAfterItemRemove: function(){},

			// Sort functionnalities
			sortable: true,
			sortFunction: $.fn.sortFunctions.alphaNumSort,
			onItemSort: function(){},
			processbuilder: true,

			// Custom selectors (prevent automatic building when provided)
			sourceListSelector: null,
			compositionListSelector: null
    	};

    	// Merge defaults and options settings
    	settings = $.extend({}, defaults, options);

    	// Store a reference to the kProcessBuilder object
        $.data(root, "kProcessBuilder", $kProcessBuilder);
    }

    // Initialize parent list (left list)
    function createParentList(){
    	$parent = $('<div>').addClass('k-processbuilder-parent').appendTo($kProcessBuilder);
    	if(settings.parentLabel){
    		$('<span>').addClass('k-processbuilder-label').html(settings.parentLabel).appendTo($parent);
    	}

    	// No need to create it if specified in the settings
    	if(settings.sourceListSelector){
    		$parentList = $(settings.sourceListSelector);
    		$parentList.removeClass().addClass("ui-sortable kprocessbuilder-list kProcessBuilder-parent-list").disableSelection().appendTo($kProcessBuilder);
    		$parentList.find("li").each(function(index, item){
    			var $item = $(item),
    				ignore = $item.is(settings.ignore);
    			$item.removeClass().addClass("ui-state-default kprocessbuilder-parent-list-row kconnected-sortable" + (ignore ? ' ignore' : ''));
    		});
    	}else if($kProcessBuilder.find('.kscrollable .kprocessbuilder-parent-list').length == 1){
    		$parentList = $kProcessBuilder.find('.kscrollable .kprocessbuilder-parent-list');
    		$parentList.find("li").each(function(index, item){
    			var $item = $(item),
    				ignore = $item.is(settings.ignore);
    			$item.removeClass().addClass("ui-state-default kprocessbuilder-parent-list-row kconnected-sortable" + (ignore ? ' ignore' : ''));
    		});
    		$parentList.closest('.kscrollable').appendTo($parent);
    	}else{
    		var $scrollable = $('<div>').addClass('kscrollable').appendTo($parent);
    		$parentList = $parentList ? $parentList.empty() : $("<ul>").addClass("ui-sortable kprocessbuilder-list kprocessbuilder-parent-list").disableSelection().appendTo($scrollable);
    	}
    }

    // Initialize composition list
    function createCompositionList(){
    	$composition = $('<div>').addClass('k-processbuilder-composition').appendTo($kProcessBuilder);
    	if(settings.compositionLabel){
    		$('<span>').addClass('k-processbuilder-label').html(settings.compositionLabel).appendTo($composition);
    	}

    	// No need to create it if specified in the settings
    	if(settings.compositionListSelector){
    		$compositionList = $(settings.compositionListSelector);
    		$compositionList.removeClass().addClass("ui-sortable kprocessbuilder-list kprocessbuilder-composition-list").disableSelection().appendTo($kProcessBuilder);
    		$compositionList.find("li").removeClass().addClass("ui-state-default kprocessbuilder-composition-list-row kconnected-sortable");
    	}else if($kProcessBuilder.find('.kscrollable .kprocessbuilder-composition-list').length == 1){
    		$compositionList = $kProcessBuilder.find('.kscrollable .kprocessbuilder-composition-list');
    		$compositionList.closest('.kscrollable').appendTo($composition);
    	}else{
    		var $scrollable = $('<div>').addClass('kscrollable').appendTo($composition);
    		$compositionList = $compositionList ? $compositionList.empty() : $("<ul>").addClass("ui-sortable kprocessbuilder-list kprocessbuilder-composition-list").disableSelection().appendTo($scrollable);
    	}

    	if(settings.sortable){
    		var wrapperSelector = "#" + $kProcessBuilder.attr("id");
        	$kProcessBuilder.find(".kprocessbuilder-parent-list, .kprocessbuilder-composition-list").sortable({
        	    connectWith: wrapperSelector + " .kprocessbuilder-list",
        	    items: 'li:not(' + settings.ignore + ')',
  				over: onOver,
  				out: onOut,
        	    stop: onDrop,
        	    delay: 300,
        	    revert: 0,
        	    helper: createHelper,
        	    placeholder: 'ksortable-placeholder',
        	    forcePlaceholderSize: true,
        	    opacity: 0.9,
        	    smooth: false,
        	    remove: function(event, ui){
        	    	if(ui.item && ui.item.is('.kprocessbuilder-composition-list-row')){
        	    		ui.item.remove();
        	    	}else{
        	    		ui.item.clone().appendTo($compositionList);
        	    		$(this).sortable('cancel');
        	    	}
        	    }
        	}).disableSelection();
        	$parentList.children().addClass("draggable");
    		$compositionList.children().addClass("draggable");
        	handleStates();
    	}
    }

    // Function used to create old interactions toolbox
    function createOldModeToolbox(){

    	// Add and remove buttons
    	var $target = settings.sourceListSelector ? $parentList : $parentList.parent();
    	$oldEditToolbox = $oldEditToolbox ? $oldEditToolbox.empty() : $("<div>").addClass("kold-edit-toolbox").insertAfter($target);
		$("<button type=\"button\">").button({
			text: false,
			icons: {
				primary: "ui-icon-plus"
			}
		}).addClass("kold-edit-button kold-edit-add").click(oldAddAction).appendTo($oldEditToolbox);
		$("<button type=\"button\">").button({
			text: false,
			icons: {
				primary: "ui-icon-minus"
			}
		}).addClass("kold-edit-button kold-edit-remove").click(removeAction).appendTo($oldEditToolbox);

    	// Sort buttons
    	$target = settings.compositionListSelector ? $compositionList : $compositionList.parent();
    	$oldSortToolbox = $oldSortToolbox ? $oldSortToolbox.empty() : $("<div>").addClass("kold-edit-toolbox").insertAfter($target);
    	$("<button type=\"button\">").button({
			text: false,
			icons: {
				primary: "ui-icon-triangle-1-n"
			}
		}).click(oldSortUpAction).addClass("kold-edit-button kold-edit-sort-up").appendTo($oldSortToolbox);
		$("<button type=\"button\">").button({
			text: false,
			icons: {
				primary: "ui-icon-triangle-1-s"
			}
		}).click(oldSortDownAction).addClass("kold-edit-button kold-edit-sort-down").appendTo($oldSortToolbox);
    }

    // Function used to wrap actions passed through instanciation options
    function executeAction(action, params){
    	if(action){
    		if(typeof(action) == "function"){
    			action(params);
    		}
    	}
    }

    function createHelper(e, item){
        var $target = $(e.currentTarget),
        	helper = $('<li/>').attr('data-value', item.data('value')).addClass("kprocessbuilder-composition-list-row kconnected-sortable ui-state-highlight ");
        if($target.is('.kprocessbuilder-parent-list')){
        	helper.addClass('state-add');
        }else{
        	helper.addClass('state-remove');
        }
        if (!item.hasClass('ui-state-highlight')) {
            item.addClass('ui-state-highlight').siblings().removeClass('ui-state-highlight');
        }
        var elements = item.parent().children('.ui-state-highlight').clone(true, true);
        item.data('multidrag', elements);
        item.siblings('.ui-state-highlight').remove();
        return helper.append(elements);
    }

    //////////////////////////////////////////////////
    //					UI Updates					//
    //////////////////////////////////////////////////

    // Binds mouse events to update items' visual states
    function handleStates(){

    	// So we don't trigger events more than once
    	$kProcessBuilder.find("li.kconnected-sortable").unbind('click mouseenter mouseleave');

    	$kProcessBuilder.find("li.kconnected-sortable").hover(function(e) {
            $(this).addClass('ui-state-hover');
        }, function(){
        	$(this).removeClass('ui-state-hover');
        });

    	$kProcessBuilder.find("li.kconnected-sortable").click(function(e) {
    		var $this = $(this),
    			$otherLists = $(e.currentTarget).closest('.k-processbuilder-parent').length > 0 ? $composition : $parent;
    		if($otherLists.length != 0){
    			$otherLists.find('.kconnected-sortable').removeClass('ui-state-highlight ui-state-hover');
    		}
    		$this.addClass('ui-state-highlight').siblings('.kconnected-sortable').removeClass('ui-state-highlight ui-state-hover');
            updateOldToolbox();
            return false;
        });
    }

    // Assert composition items consistency according to initialization options
    function updateCompositionItems(){
    	$compositionList.find('li').each(function(){
    		var $this = $(this),
    			$label = $this.find('span.composition-list-label'),
    			ignore = $this.is(settings.ignore);

    		// Clean li
    		$this.find('div, button').remove();
			$this.find('span.klist-icon').remove();
			if($label.length == 0){
				var text = $this.html();
				$this.empty();
				$label = $('<span>').addClass('composition-list-label').html(text).appendTo($this);
			}
			$this.removeClass().addClass('ui-state-default kprocessbuilder-composition-list-row kconnected-sortable' + (ignore ? ' ignore' : ''));

			// Add helpers and buttons according to the settings
    		if(settings.sortable){
    			if(!ignore){
    				$this.addClass('draggable');
    				$('<span>').addClass('ui-icon ui-icon-arrowthick-2-n-s klist-icon').prependTo($this);
    			}else{
    				$('<span>').addClass('ui-icon ui-icon-locked klist-icon').prependTo($this);
    			}
    		}
    		if(settings.removable && !ignore){
    			$('<button type=\"button\">').button({
	    			text: false,
	    			icons: {
	    				primary: 'ui-icon-minus'
	    			}
	    	    }).click(function(){
	    	    	settings.onBeforeItemRemove($compositionList, $this);

	    	    	$this.detach();

	    	    	settings.onAfterItemRemove($compositionList, $this);

	    	    	updateCompositionItems();
	    	    	updateParentItems();
	    	    	return false;
	    	    }).addClass('klist-button').appendTo($this);
    		}
    		if($this.data('params') && settings.editable && !ignore){
    			$('<button type=\"button\">').button({
	    			text: false,
	    			icons: {
	    				primary: 'ui-icon-wrench'
	    			}
	    	    }).click(function(e){
	    	    	e.preventDefault();
	    	    	settings.onBeforeItemEdit($compositionList, $(this).closest('li'));

	    	    	executeAction(settings.editAction, $(this).closest('li'));

	    	    	settings.onAfterItemEdit($compositionList, $(this).closest('li'));
	    	    	return false;
	    	    }).addClass('klist-button').appendTo($this);
    		}
    		if(!$this.attr('title')){
        		$this.attr('title', $label.text());
    		}
    	});
    }

    // Update items from parent list
    function updateParentItems(){
    	if($parentList){
	    	$parentList.find("li").each(function(){
	    		var $this = $(this),
    				$label = $this.find('span.parent-list-label');

        		// Clean li
	    		$this.find("div, button").remove();
				$this.find("span.klist-icon").remove();
				$this.removeClass('kprocessbuilder-composition-list-row').addClass('kprocessbuilder-parent-list-row');
				$('<span>').addClass('ui-icon ui-icon-gear klist-icon').prependTo($this);
    			if($label.length == 0){
    				var text = $this.html();
    				$this.empty();
    				$label = $('<span>').addClass('parent-list-label').html(text).appendTo($this);
    			}

				$("<button type=\"button\">").button({
	    			text: false,
	    			icons: {
	    				primary: "ui-icon-plusthick"
	    			}
	    		}).addClass("klist-button").click({row : $this}, oldAddAction).appendTo($this);
	    	});
	    	sortParentItems();
    	}
    }


    // Update old toolbox states
    function updateOldToolbox(){
    	var $selectedCompositionRows = $compositionList.find(".ui-state-highlight"),
			ignorableCompositionRows = $selectedCompositionRows.is(settings.ignore);
    	if($oldEditToolbox){
    		var $selectedParentRows = $parentList.find(".ui-state-highlight"),
				ignorableParentRows = $selectedParentRows.is(settings.ignore);
	    	// Manage add button states
	    	if($parentList && ($parentList.children().length <= 0 || $selectedParentRows.length <= 0 || ignorableParentRows)){
	    		$oldEditToolbox.find(".kold-edit-add").button( "option", "disabled", true );
	    	}else{
	    		$oldEditToolbox.find(".kold-edit-add").button( "option", "disabled", false );
	    	}

	    	// Manage remove button states
	    	if($compositionList.children().length <= 0 || $selectedCompositionRows.length <= 0 || ignorableCompositionRows){
	    		$oldEditToolbox.find(".kold-edit-remove").button( "option", "disabled", true );
	    	}else{
	    		$oldEditToolbox.find(".kold-edit-remove").button( "option", "disabled", false );
	    	}
    	}

    	if($oldSortToolbox){
	    	// Manage sort up button states
	    	if($compositionList.children().length <= 0 ||
	    	   $selectedCompositionRows.length > 1 ||
	    	   $selectedCompositionRows.length == 0 ||
	    	   $selectedCompositionRows.index() == 0 ||
	    	   ignorableCompositionRows){

	    		$oldSortToolbox.find(".kold-edit-sort-up").button( "option", "disabled", true );

	    	}else{
	    		$oldSortToolbox.find(".kold-edit-sort-up").button( "option", "disabled", false );
	    	}

	    	// Manage sort down button states
	    	if($compositionList.children().length <= 0 ||
	    	   $selectedCompositionRows.length > 1 ||
	    	   $selectedCompositionRows.length == 0 ||
	    	   $selectedCompositionRows.index() == ($compositionList.children().length - 1) ||
	    	   ignorableCompositionRows){

	    		$oldSortToolbox.find(".kold-edit-sort-down").button( "option", "disabled", true );

	    	}else{
	    		$oldSortToolbox.find(".kold-edit-sort-down").button( "option", "disabled", false );
	    	}
    	}
    }

    function sortParentItems(){
    	var $parentListLi = $('li', $parentList);
    	$parentListLi.sort(settings.sortFunction);
    	$.each($parentListLi, function(index, row){
    		$parentList.append(row);
    	});
    }

    //////////////////////////////////////////////////
    //				Events Handling					//
    //////////////////////////////////////////////////

    // Triggered when an item is dropped on a list
    function onDrop( event, info ){
    	var $removedList = $(event.target),
			$addedList;

    	if($removedList.hasClass("kprocessbuilder-composition-list")){
    		$addedList = $parentList;
    	}else{
    		$addedList = $compositionList;
    	}

    	if($.contains($removedList[0], info.item[0])){
    		var $firstElement = $compositionList.find('li[data-value="' + info.item.data('value') + '"]');
    		$kProcessBuilder.find('.kscrollable').removeClass('droppable');
    		settings.onBeforeItemAdd($addedList, info.item.data('multidrag'));
	        info.item.after(info.item.data('multidrag'));
	        $firstElement.remove();
	        settings.onAfterItemAdd($addedList, info.item.data('multidrag') || []);
	    	info.item.remove();
    		settings.onItemSort($removedList);
    	}else{
	    	settings.onBeforeItemAdd($addedList, info.item.data('multidrag'));
	    	if($removedList) settings.onBeforeItemRemove($removedList, info.item.data('multidrag'));

	    	$kProcessBuilder.find('.kscrollable').removeClass('droppable');
	        info.item.after(info.item.data('multidrag'));

	        settings.onAfterItemAdd($addedList, info.item.data('multidrag'));
	    	if($removedList) settings.onAfterItemRemove($removedList, info.item.data('multidrag'));

	    	info.item.remove();
    	}

    	updateCompositionItems();
    	updateParentItems();
    	updateOldToolbox();
    	handleStates();
    }

    // Triggered when drag starts
    function onStart(e, info){
    	if(userAgent.match(/firefox/)) {
    	    info.item.css('margin-top', $(window).scrollTop());
    	}
    }

    // Triggered just before drag stops
    function onBeforeStop(e, info){
    	if(userAgent.match(/firefox/)) {
    		info.item.css('margin-top', 0 );
    	}
    }

    // Triggered when a list item is dragged over
    function onOver(e, info){
    	if(info.sender.is('.kprocessbuilder-parent-list')){
    		info.helper.removeClass('state-add state-remove').addClass('state-add');
    	}else{
    		info.helper.removeClass('state-add state-remove').addClass('state-remove');
    	}
    	$kProcessBuilder.find('.kscrollable').removeClass('droppable');
    	$(e.target).closest('.kscrollable').addClass('droppable');
    }

    // Triggered when a list item is dragged out
    function onOut(e, info){
    	$kProcessBuilder.find('.kscrollable').removeClass('droppable');
    	$(e.target).closest('.kscrollable').addClass('droppable');
    }

    // Triggered when remove button is clicked
    function removeAction(selector){
    	var $rows = selector && (typeof selector == 'string') ? $compositionList.find(selector) : $compositionList.find("li.ui-state-highlight"),
    		result = settings.onBeforeItemRemove($compositionList, $rows),
    		proceed = result ? result : true;

    	if(proceed){
    		$rows.detach();
	    	updateCompositionItems();
	    	updateParentItems();
	    	updateOldToolbox();
	    	settings.onAfterItemRemove($compositionList, $rows);
    	}
    }

    // Triggered when old add button is clicked
    function oldAddAction(event){
    	event.preventDefault();
    	var $rows;
    	if(event.data && event.data.row){
    		$rows = event.data.row.clone();
    	}else{
        	$rows = $parentList.find("li.ui-state-highlight").clone();
    	}

    	settings.onBeforeItemAdd($compositionList, $rows);

    	$rows.appendTo($compositionList);

    	updateCompositionItems();
    	updateParentItems();
    	updateOldToolbox();
		handleStates();

    	settings.onAfterItemAdd($compositionList, $rows);
    	return false;
    }

    // Triggered when old sort up button is clicked
    function oldSortUpAction(){
    	//$( ".selector" ).sortable( "refreshPositions" );
    	$compositionList.find("li.ui-state-highlight").each(function(){
    		$(this).insertBefore($(this).prev());
    	});
    	updateOldToolbox();
    	settings.onItemSort($compositionList);
    	return false;
    }

    // Triggered when old sort down button is clicked
    function oldSortDownAction(){
    	$compositionList.find("li.ui-state-highlight").each(function(){
    		$(this).insertAfter($(this).next());
    	});
    	updateOldToolbox();
    	settings.onItemSort($compositionList);
    	return false;
    }

    //////////////////////////////////////////////////


    //////////////////////////////////////////////////
    //						API						//
    //////////////////////////////////////////////////

    $kProcessBuilder.add = function($item, prepend){

    	settings.onBeforeItemAdd($compositionList, $item);

    	if(prepend){
    		$item.prependTo($compositionList);
    	}else{
        	$item.appendTo($compositionList);
    	}
    	this.update();

    	settings.onAfterItemAdd($compositionList, $item);
    };

    // TODO : voir pour ajouter la possibilité de supprimer un item directement
    $kProcessBuilder.remove = function(selector){
    	removeAction(selector);
    };

    $kProcessBuilder.update = function(){
    	updateCompositionItems();
    	updateParentItems();
    	updateOldToolbox();
    	handleStates();
    };

    //////////////////////////////////////////////////

    // Browser variables
	var msie = (/msie ([\w.]+)/i.exec(ua)||[])[1],
    opera = /opera/i.test(ua),
    safari = /webkit/i.test(ua) && !/chrome/i.test(ua);

	// Initialize the component
	init();

	// Create the toolbox if necessary
	createParentList();
	updateParentItems();

	// Create resulting list
	createCompositionList();
	updateCompositionItems();

	// To preserve old interactions habits
	if(options.oldMode){
		createOldModeToolbox();
		updateOldToolbox();
	}

	updateOldToolbox();
};

$.fn.kProcessBuilder = function (options, params) {
    if(options){
		options = options || {};

	    if (typeof options === "object") {
		    this.each(function () {
		        if ($(this).data('kProcessBuilder')) {
		            if (options.remove) {
		                $(this).data('kProcessBuilder').remove();
		                $(this).removeData('kProcessBuilder');
		            }
		        }
		        else if (!options.remove) {
		            if (options.enable === undefined && options.disable === undefined)
		                options.enable = true;

		            new $.kProcessBuilder(this, options);
		        }
		    });

		    if (options.instance)
		        return $(this).data('kProcessBuilder');

		    return this;
	    }
	}else{
    	return $(this).data('kProcessBuilder');
    };
};

})(jQuery);
